import cookies from 'js-cookie';
import { csrfCookieName } from 'app-constants';

export default function useCSRF () {
  return cookies.get(csrfCookieName);
}
